<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-betgame-form :id="parseInt(this.$route.params.id)">

      </edit-betgame-form>
    </div>
  </div>
</template>
<script>
  import EditBetgameForm from './BGBackendEditBetgameForm.vue'

  export default {
    components: {
      EditBetgameForm
    },
    created () {
      this.$log.debug('Betgame.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('Betgame.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('Betgame.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Betgame.vue